var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContentTitle',{attrs:{"title":_vm.$t('common.welcome') + ' ' + _vm.user_token_json.u_name,"width":"90%"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }